import React, { useRef } from "react";
import AnimationBlock from "../../common/components/AnimationBlock/AnimationBlock";
import useVisiblePage from "../../common/hooks/useVisiblePage";
import { Page } from "../../common/reducers/visible-page/visible-page-types";
import Title from "../../components/Title/Title";
var Home = function () {
    var ref = useRef(null);
    useVisiblePage(ref, Page.HOME);
    return (React.createElement("div", { ref: ref, className: "home" },
        React.createElement("div", { className: "home-container" },
            React.createElement(Title, { title: "Sukrut Nadigotti", subtitle: "Software Engineer / Developer" }),
            React.createElement(AnimationBlock, { text: "SCROLL" }))));
};
export default Home;
